export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4642.230b39e8.jpg";